module.exports = __webpack_public_path__ + "assets/img/goods_adv3.da2c0c1c.jpg";